export default __webpack_public_path__ + "static/media/invite-success-img.c7a31ce9.svg";